package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

// SECTIONS DE LA PAGE DE PAIEMENT
val PaymentContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(top = 30.px, bottom = 30.px, leftRight = 40.px)
    }
    Breakpoint.MD {
        Modifier.padding(top = 50.px, bottom = 70.px, leftRight = 60.px)
    }
    Breakpoint.LG {
        Modifier
            .width(1100.px)
            .padding(top = 60.px, bottom = 100.px, leftRight = 0.px)
    }
}

val PaymentHeaderRowStyle = CssStyle {
    base { Modifier.margin(bottom = 30.px) }
    Breakpoint.MD { Modifier.margin(bottom = 60.px) }
    Breakpoint.LG { Modifier.margin(bottom = 120.px) }
}

val PaymentBackIconStyle = CssStyle {
    base { Modifier.fontSize(20.px) }
    Breakpoint.MD { Modifier.fontSize(26.px) }
    Breakpoint.LG { Modifier.fontSize(32.px) }
}

val PaymentTitleStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD { Modifier.fontSize(24.px) }
    Breakpoint.LG { Modifier.fontSize(30.px) }
}

val PaymentContentWrapperStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(30.px)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column") // Mobile : Formulaire en haut, Carte prix en bas
                property("align-items", "center")
            }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("display", "flex")
            property("flex-direction", "row") // Tablette/Desktop : Côte à côte
            property("justify-content", "space-between")
            property("align-items", "flex-start")
        }
    }
}

// FORMULAIRE DE PAIEMENT
val PaymentFormSectionStyle = CssStyle {
    base { Modifier.fillMaxWidth() }
    Breakpoint.MD { Modifier.width(300.px) }
    Breakpoint.LG { Modifier.width(600.px) }
}

val PaymentOperatorLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(16.px)
            .margin(bottom = 16.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(18.px)
            .margin(bottom = 20.px)
    }
    Breakpoint.LG { Modifier.fontSize(20.px) }
}

val PaymentOperatorsRowStyle = CssStyle {
    base { Modifier.gap(16.px) }
    Breakpoint.MD { Modifier.gap(20.px) }
    Breakpoint.LG { Modifier.gap(30.px) }
}

val PaymentPhoneLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .margin(top = 24.px, bottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(20.px)
            .margin(top = 50.px, bottom = 10.px)
    }
}

val PaymentFormButtonStyle = CssStyle {
    base {
        Modifier
            .height(48.px)
            .fontSize(18.px)
            .margin(top = 30.px)
    }
    Breakpoint.MD {
        Modifier
            .height(50.px)
            .fontSize(20.px)
            .margin(top = 80.px)
    }
    Breakpoint.LG {
        Modifier
            .height(60.px)
            .fontSize(25.px)
    }
}

// CARTE OPÉRATEUR (ORANGE / MTN)
val PaymentCardContainerStyle = CssStyle {
    base {
        Modifier
            .height(70.px)
            .padding(12.px)
            .styleModifier { property("min-width", "140px") }
    }
    Breakpoint.MD {
        Modifier
            .height(125.px)
            .padding(16.px)
            .styleModifier { property("min-width", "200px") }
    }
    Breakpoint.LG {
        Modifier
            .height(80.px)
            .padding(20.px)
            .styleModifier { property("min-width", "280px") }
    }
}

val PaymentCardInnerRowStyle = CssStyle {
    base { Modifier.gap(10.px) }
    Breakpoint.MD { Modifier.gap(15.px) }
    Breakpoint.LG { Modifier.gap(30.px) }
}

val PaymentCardDotIndicatorStyle = CssStyle {
    base { Modifier.size(6.px) }
    Breakpoint.MD { Modifier.size(8.px) }
}

val OrangeImageStyle = CssStyle {
    base {
        Modifier
            .width(80.px)
            .height(40.px)
    }
    Breakpoint.MD {
        Modifier
            .width(190.px)
            .height(50.px)
    }
}

val MtnImageStyle = CssStyle {
    base {
        Modifier
            .width(80.px)
            .height(40.px)
    }
    Breakpoint.MD {
        Modifier
            .width(160.px)
            .height(75.px)
    }
}

// CARTE RÉSUMÉ DE PRIX
val PriceSummaryCardStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(24.px)
    }
    Breakpoint.MD {
        Modifier
            .width(320.px)
            .padding(30.px)
    }
    Breakpoint.LG {
        Modifier
            .width(380.px)
            .padding(40.px)
    }
}

val PriceSummaryRowStyle = CssStyle {
    base { Modifier.margin(bottom = 20.px) }
    Breakpoint.MD { Modifier.margin(bottom = 30.px) }
}

val PriceSummaryAmountTextStyle = CssStyle {
    base { Modifier.fontSize(26.px) }
    Breakpoint.MD { Modifier.fontSize(30.px) }
    Breakpoint.LG { Modifier.fontSize(35.px) }
}

val PriceSummarySubtextStyle = CssStyle {
    base { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
}

val PriceSummaryFeaturesContainerStyle = CssStyle {
    base { Modifier.margin(top = 15.px) }
    Breakpoint.MD { Modifier.margin(top = 20.px) }
}

// POPUP D'INCOMPATIBILITÉ
val IncompatibilityPopupOverlayStyle = CssStyle {
    base { Modifier.padding(leftRight = 20.px) }
    Breakpoint.MD { Modifier.padding(leftRight = 24.px) }
}

val IncompatibilityPopupCardStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderRadius(18.px)
            .padding(topBottom = 28.px, leftRight = 22.px)
    }
    Breakpoint.MD {
        Modifier
            .width(340.px)
            .borderRadius(24.px)
            .padding(topBottom = 34.px, leftRight = 32.px)
    }
    Breakpoint.LG {
        Modifier
            .width(380.px)
            .padding(topBottom = 40.px, leftRight = 40.px)
    }
}

val IncompatibilityPopupEmojiStyle = CssStyle {
    base {
        Modifier
            .fontSize(32.px)
            .margin(bottom = 12.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(40.px)
            .margin(bottom = 16.px)
    }
}

val IncompatibilityPopupTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(17.px)
            .margin(bottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(20.px)
            .margin(bottom = 12.px)
    }
}

val IncompatibilityPopupTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(13.5.px)
            .margin(bottom = 22.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(15.px)
            .margin(bottom = 30.px)
    }
}

val IncompatibilityPopupButtonTextStyle = CssStyle {
    base {
        Modifier
            .height(44.px)
            .fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier
            .height(50.px)
            .fontSize(16.px)
    }
}